import http from "./http-common";
import AppointmentModel from "../models/appointment";

// Navbar APIs
// eslint-disable-next-line
export default new (class AppointmentService {
  // Get all members
  async getAppointment() {
    return await http
      .get("/appointment-services?pLevel")
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((appointment) =>
            AppointmentModel.get(appointment)
          )
        );

        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // Get by Id
  async getAppointmentByName(name) {
    return await http
      .get("/appointment-services?pLevel")
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data
            .filter((i) => i?.link?.href === name)
            .map((appointment) => AppointmentModel.get(appointment))
        );

        return data[0];
      })
      .catch((error) => {
        console.log(error);
      });
  }
})();
